import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    this.debouncedSubmit = window.helpers.debounce(this.submit.bind(this), 200)
  }

  submit() {
    this.element.requestSubmit()
  }

  // Can be used when the submit button is outside the form e.g. form in dl.body and submit in dl.footer
  submitFormTarget(event) {
    event.preventDefault()

    this.formTarget.requestSubmit()
  }

  debounceSubmit() {
    this.debouncedSubmit()
  }
}
